
  (function() {
    class SizeGuideadwztt0roenpkqvm2uaigenblockc1150e97tafbn extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.buttons = this.querySelectorAll('.ai-size-guide-toggle-btn-adwztt0roenpkqvm2uaigenblockc1150e97tafbn');
        this.values = this.querySelectorAll('.ai-size-guide-value-adwztt0roenpkqvm2uaigenblockc1150e97tafbn');
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const unit = button.getAttribute('data-unit');
            this.switchUnit(unit);
          });
        });
      }

      switchUnit(unit) {
        this.buttons.forEach((btn) => {
          const btnUnit = btn.getAttribute('data-unit');
          if (btnUnit === unit) {
            btn.classList.add('active');
            btn.setAttribute('aria-pressed', 'true');
          } else {
            btn.classList.remove('active');
            btn.setAttribute('aria-pressed', 'false');
          }
        });

        this.values.forEach((value) => {
          const valueUnit = value.getAttribute('data-unit');
          if (valueUnit === unit) {
            value.classList.add('active');
          } else {
            value.classList.remove('active');
          }
        });
      }
    }

    if (!customElements.get('size-guide-adwztt0roenpkqvm2uaigenblockc1150e97tafbn')) customElements.define('size-guide-adwztt0roenpkqvm2uaigenblockc1150e97tafbn', SizeGuideadwztt0roenpkqvm2uaigenblockc1150e97tafbn);
  })();


  (function() {
    class TwoColumnContentaafyytu1ozjv5mfcrcaigenblock92f7457hftmqa extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
      }
    }

    if (!customElements.get('two-column-content-aafyytu1ozjv5mfcrcaigenblock92f7457hftmqa')) customElements.define('two-column-content-aafyytu1ozjv5mfcrcaigenblock92f7457hftmqa', TwoColumnContentaafyytu1ozjv5mfcrcaigenblock92f7457hftmqa);
  })();


  (function() {
    class TwoColumnContentarmrkuzzkm1jkm2y0vaigenblock92f74579bhtep extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
      }
    }

    if (!customElements.get('two-column-content-armrkuzzkm1jkm2y0vaigenblock92f74579bhtep')) customElements.define('two-column-content-armrkuzzkm1jkm2y0vaigenblock92f74579bhtep', TwoColumnContentarmrkuzzkm1jkm2y0vaigenblock92f74579bhtep);
  })();


  (function() {
    class TwoColumnContentaamdaly9lmlpqyzdmnaigenblock92f7457bj3hp8 extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
      }
    }

    if (!customElements.get('two-column-content-aamdaly9lmlpqyzdmnaigenblock92f7457bj3hp8')) customElements.define('two-column-content-aamdaly9lmlpqyzdmnaigenblock92f7457bj3hp8', TwoColumnContentaamdaly9lmlpqyzdmnaigenblock92f7457bj3hp8);
  })();


  (function() {
    class SizeGuideTableaa2vctkjdtlndr0tkeaigenblocka166f8elxnrbc extends HTMLElement {
      constructor() {
        super();
        this.toggleButtons = this.querySelectorAll('.ai-size-guide-toggle-btn-aa2vctkjdtlndr0tkeaigenblocka166f8elxnrbc');
        this.tables = this.querySelectorAll('.ai-size-guide-dataset-aa2vctkjdtlndr0tkeaigenblocka166f8elxnrbc');
      }

      connectedCallback() {
        this.setupToggleButtons();
      }

      setupToggleButtons() {
        this.toggleButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const unit = button.getAttribute('data-unit');

            this.toggleButtons.forEach((btn) => btn.classList.remove('active'));
            button.classList.add('active');

            this.tables.forEach((table) => {
              if (table.getAttribute('data-unit') === unit) {
                table.classList.add('active');
              } else {
                table.classList.remove('active');
              }
            });
          });
        });
      }
    }

    if (!customElements.get('size-guide-table-aa2vctkjdtlndr0tkeaigenblocka166f8elxnrbc')) customElements.define('size-guide-table-aa2vctkjdtlndr0tkeaigenblocka166f8elxnrbc', SizeGuideTableaa2vctkjdtlndr0tkeaigenblocka166f8elxnrbc);
  })();

(function(){if(!customElements.get('ai-two-column-images-aaxfpngvfd0kzk0vwdaigenblock54fc904dgfwjd')){class AiTwoColumnImagesaaxfpngvfd0kzk0vwdaigenblock54fc904dgfwjd extends HTMLElement{}customElements.define('ai-two-column-images-aaxfpngvfd0kzk0vwdaigenblock54fc904dgfwjd',AiTwoColumnImagesaaxfpngvfd0kzk0vwdaigenblock54fc904dgfwjd);}})();
(function(){if(!customElements.get('ai-two-column-images-au3a3t1z6tndjb084taigenblock54fc904tqmqwk')){class AiTwoColumnImagesau3a3t1z6tndjb084taigenblock54fc904tqmqwk extends HTMLElement{}customElements.define('ai-two-column-images-au3a3t1z6tndjb084taigenblock54fc904tqmqwk',AiTwoColumnImagesau3a3t1z6tndjb084taigenblock54fc904tqmqwk);}})();